import SideBar from "../components/SideBar"
import {useState,useEffect} from 'react'
import { useParams,useNavigate } from "react-router-dom"
import {useDispatch, useSelector} from "react-redux"
import { editGenre, fetchGenre, genreDetail } from "../store/actions"
import Swal from "sweetalert2"
export default function EditGenre(){
    const navigate= useNavigate()
    const dispatch= useDispatch()
    const {detailGenre}= useSelector((state)=>state.genre)
   const {id}= useParams()
    const [genre,setGenre]= useState({
        name:""
    })

    const inputEditGenre= (e)=>{
        const{name,value}= e.target
        setGenre({
            ...genre,
            [name]: value
        })
    }

    useEffect(()=>{
       dispatch(genreDetail(id))
    },[])

    useEffect(()=>{
        if(detailGenre.name){
            setGenre({
                name: detailGenre.name
            })
        }
    },[detailGenre])

    const EditGenreHandler= (e)=>{
        e.preventDefault();
       dispatch(editGenre(id,genre))
       .then((response)=>{
        return response.json()
     })
     .then((data)=>{
        if(data.message){
            navigate(`/editGenre/${id}`)
           Swal.fire({
            icon:'error',
            title: data.message
           })
        }else{
            Swal.fire({
                icon:'success',
                title: `Success edit genre id ${id}`
               })
            dispatch(fetchGenre())
            navigate('/genre')
        }
         
      })
      .catch((error)=>{
         console.log(error);
      })
    }

    return(
        <div>
        <SideBar/>
        <div>
            <div>
            <form onSubmit={EditGenreHandler}>
<div className="justify-center items-center flex flex-col" style={{height:"100vh"}}>
<div className="text-center rounded-lg pt-20" style={{width: "1000px", height: "800px"}}>
<p className="font-bold" style={{fontSize: "15pt"}}>Edit Genre</p>
<div className="pt-5">
<label>Name:</label><br/>
<input value={genre.name} name="name" onChange={inputEditGenre}  type="text" style={{width: "300px", height:"35px"}} placeholder="Title" className="border-2 rounded-md pl-2"/>
</div>
<div className="pt-5 pb-10">
<button className="bg-purple-400 h-8 rounded-lg hover:bg-purple-300"  style={{width: "300px", height:"35px"}}>Submit</button>
</div>
</div>
</div>
</form>
            </div>
        </div>
    </div>
    )
}